// Helpers for deciding how to render CMS values that may arrive either as
// plain text or as authored HTML. Deliberately dependency-free and free of any
// DOM access so they can run during the Gatsby SSR build.

// Matches a value that opens with a tag and closes with one, allowing any
// content (including newlines and sibling elements) in between. This is the
// more permissive of the sniff patterns already in the codebase - the `.+`
// variants used elsewhere mishandle multi-line content.
// No `g` flag: a shared global regex carries `lastIndex` between `.test()`
// calls and would return alternating results.
const HTML_PATTERN = /^<[^>]+>[\s\S]*<\/[^>]+>$/;

// Matches an anchor anywhere in the value - not just a value that IS an anchor.
// CMS editors commonly wrap authored markup (`<p><a ...>...</a></p>`), and an
// anchor nested at any depth still triggers the parser's nested-link recovery.
const CONTAINS_ANCHOR_PATTERN = /<a\b[^>]*>/i;

/** True when the value looks like authored HTML rather than plain text. */
export const looksLikeHtml = (value?: string): boolean =>
    !!value && HTML_PATTERN.test(value.trim());

/**
 * True when the value contains an anchor. Such a value must replace a link
 * wrapper rather than being injected inside one - nested anchors are invalid
 * and the HTML parser splits them into broken sibling markup.
 */
export const containsAnchor = (value?: string): boolean =>
    !!value && CONTAINS_ANCHOR_PATTERN.test(value);
